export default angular
  .module("OrganizationsCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("OrganizationsController", [
    "$scope",
    "$modal",
    "$state",
    "$http",
    "$rootScope",
    "$translate",
    "$filter",
    "System",
    "modal",
    function (
      $scope,
      $modal,
      $state,
      $http,
      $rootScope,
      $translate,
      $filter,
      System,
      modal,
    ) {
      $rootScope.page = "organizations";
      $scope.organizationPageSize = 20;
      $scope.sortOrganizations = [];
      $scope.sortOrganizations.column = "NAME";
      $scope.sortOrganizations.direction = false; // ascending direction

      // Sets table sort according to COLUMN
      // Also toggles between ascending and descending
      $scope.changeSorting = function (column) {
        if ($scope.sortOrganizations.column == column) {
          $scope.sortOrganizations.direction = !$scope.sortOrganizations
            .direction;
        } else {
          $scope.sortOrganizations.column = column;
          $scope.sortOrganizations.direction = false;
        }
      };

      // list of organizations
      System.loadOrganizations((data) => {
        $scope.organizations = data;
      });

      // user clicked an organization and details are shown
      $scope.openOrganization = function (organization) {
        $rootScope.page = "organizationdetails";
        $scope.selectedorganization = organization;
      };

      $rootScope.$on("addOrganization", () => {
        $scope.selectedorganization = {};
        System.updateOrganization($scope.selectedorganization, (data2) => {
          System.loadOrganizations((data) => {
            $scope.organizations = data;
            for (let i = 0; $scope.organizations.length > i; i++) {
              if (data2.NEWID[0] == $scope.organizations[i].ID) {
                $scope.selectedorganization = $scope.organizations[i];
                $rootScope.page = "organizationdetails";
              }
            }
          });
        });
      });

      $rootScope.$on("saveOrganization", () => {
        System.updateOrganization($scope.selectedorganization, () => {});
      });

      $rootScope.$on("deleteOrganization", () => {
        modal.openDelete($scope.selectedorganization.NAME, "Organization").result.then(() => {
          System.deleteOrganization($scope.selectedorganization, () => {
            System.loadOrganizations((data) => {
              $scope.organizations = data;
              $scope.selectedorganization = {};
              $rootScope.page = "organizations";
            });
          });
        });
      });
    },
  ]);
